import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/800.css';
import { StrictMode } from 'react';
import { createRoot,hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LazyMotion,domAnimation } from 'framer-motion';

// Import chunk error handler early
import './utils/chunkErrorHandler';
import { initFontOptimization } from './utils/fontLoader';
import { AppRecovery } from './utils/appRecovery';

// Initialize font optimization
initFontOptimization();

// Initialize app recovery mechanisms
AppRecovery.initializeRecovery();

// Polyfill for requestIdleCallback - moet als eerste voor alle browsers
if (!('requestIdleCallback' in window)) {
  (window as any).requestIdleCallback = function(callback: any, options?: any) {
    const timeout = options?.timeout || 1;
    const start = Date.now();
    return window.setTimeout(() => {
      callback({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
      });
    }, timeout);
  };
  
  (window as any).cancelIdleCallback = function(handle: number) {
    window.clearTimeout(handle);
  };
}

import App from './App';
import { initAnalytics } from './utils/initAnalytics';
import './index.css';

// Initialize analytics
initAnalytics();

// Get root element
const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

// Wrap render in try-catch for additional safety
try {
  const application = (
    <StrictMode>
      <BrowserRouter>
        <HelmetProvider>
          <LazyMotion features={domAnimation} strict>
            <App />
          </LazyMotion>
        </HelmetProvider>
      </BrowserRouter>
    </StrictMode>
  );
  if (container.dataset.prerendered === 'true') {
    hydrateRoot(container, application);
  } else {
    createRoot(container).render(application);
  }
  
  // Signaleer aan het index.html-vangnet dat de app daadwerkelijk gemount is,
  // zodat de 10s auto-reload niet onnodig afvuurt.
  (window as any).__appMounted = true;
  if ((window as any).__loadFailTimeout) {
    clearTimeout((window as any).__loadFailTimeout);
  }

  // Reset retry count on successful render
  AppRecovery.resetRetryCount();
} catch (error) {
  console.error('Failed to render app:', error);
  AppRecovery.handleLoadingError();
}
